import StandardSkillsSerializer from '../serializers/StandardSkillsSerialier';
import {StandardSkill} from '../types';

import * as api from '../../../../lib/api/v1/index';

export type StandardSkillsQuery = {
  occupationResourceId?: string;
  skillCategory?: string;
};

export class StandardSkillsService {
  async getStandardSkills(
    currentLanguage: 'en' | 'de',
    query?: StandardSkillsQuery
  ): Promise<StandardSkill[]> {
    try {
      const response = await api.getStandardSkills(query);
      if (response.ok) {
        const payload = await response.json();
        const skills = StandardSkillsSerializer.toObjects(payload);

        const filteredSkills: StandardSkill[] = [];
        const names: string[] = [];
        skills.forEach((skill: StandardSkill) => {
          if (!names.includes(skill.name[currentLanguage])) {
            names.push(skill.name[currentLanguage]);
            filteredSkills.push(skill);
          }
        });

        return filteredSkills;
      }
      throw new Error('Could not get standard skills');
    } catch (error: unknown) {
      console.error('This is the error:', error);
      throw new Error('Could not get standard skills');
    }
  }
}
